/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import "./GestionDiffuseurCard.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Dropdown } from "primereact/dropdown";
import BtnBleu from "Components/Boutons/BtnBleu/btn-bleu";
import settingsBlanc from "assets/settingsBlanc.png";
import { BsGearFill } from "react-icons/bs";
import Modal from "Components/Modal/Modal";
import { Checkbox } from "@material-ui/core";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";

const GestionDiffuseurCard = (props) => {
  // const defaultValues = props.value;
  const values = {
    ...props.diffuseurInfos,
  };

  // Liste des durées d'affichage d'une offre
  const delaiData = [
    { name: "1 mois", label: 1 },
    { name: "2 mois", label: 2 },
    { name: "3 mois", label: 3 },
    { name: "4 mois", label: 4 },
    { name: "5 mois", label: 5 },
    { name: "6 mois", label: 6 },
    { name: "7 mois", label: 7 },
    { name: "8 mois", label: 8 },
    { name: "9 mois", label: 9 },
    { name: "10 mois", label: 10 },
    { name: "11 mois", label: 11 },
    { name: "12 mois", label: 12 },
  ];

  const [isFlux, setIsFlux] = useState(values.flow);
  const [isValidation, setIsValidation] = useState(values.automaticValidation);
  const [currentPusblishDuration, setCurrentPusblishDuration] = useState(
    values.validityPeriod !== ""
      ? delaiData.filter((delai) => delai.name === values.validityPeriod)[0]
      : delaiData[0]
  );
  const [isModifying, setIsModifying] = useState(false);

  return (
    <div className="gestion_diffuseur_formulaire cardHover">
      {/* <div className="gestion_diffuseur_formulaire__field_image">
        <img src={values.imageUrl} alt="Logo" title="Logo" />
      </div> */}
      <div className="gestion_diffuseur_formulaire__field_title">
        <h1>{values.name}</h1>
      </div>
      <div className="gestion_diffuseur_formulaire__field">
        <label>Flux diffuseur:</label>
        <label>{isFlux ? "Actif" : "Inactif"}</label>
      </div>
      <div className="gestion_diffuseur_formulaire__field">
        <label>Validation automatique des offres:</label>
        <label>{isValidation ? "Actif" : "Inactif"}</label>
      </div>
      <div className="gestion_diffuseur_formulaire__field">
        <label>Durée de validité des offres:</label>
        <label>{currentPusblishDuration.name}</label>
      </div>
      <div className="gestion_diffuseur_formulaire__gear">
        <BsGearFill
          src={settingsBlanc}
          className="cog-annuaire"
          onClick={() => {
            setIsModifying(true);
          }}
        />
      </div>

      <Modal
        visible={isModifying}
        setVisible={setIsModifying}
        header="Modifier le flux diffuseur"
      >
        <div className="gestion_diffuseur_formulaire__form_columns">
          <div className="field">
            <Checkbox
              id="cb1"
              onChange={(e) => setIsFlux(!isFlux)}
              checked={isFlux}
            ></Checkbox>
            <label htmlFor="cb1" className="p-checkbox-label">
              Activer le flux des offres de ce diffuseur
            </label>
          </div>

          <div className="field">
            <Checkbox
              id="cb2"
              onChange={(e) => setIsValidation(!isValidation)}
              checked={isValidation}
            ></Checkbox>
            <label htmlFor="cb2" className="p-checkbox-label">
              Activer la validation automatique des offres de ce diffuseur
            </label>
          </div>

          <div className="field">
            <div className="field_right">
              <label>{"Delai d'affichage des offres"}</label>
              <Dropdown
                options={delaiData}
                value={currentPusblishDuration}
                onChange={(e) => {
                  setCurrentPusblishDuration(e.target.value);
                }}
                optionLabel="name"
              />
            </div>
          </div>
          <div className="modify_flux_button">
            <BtnBleu
              btnAction={() => {
                const sendedBody = {
                  name: values.name,
                  imageUrl: values.imageUrl,
                  flow: isFlux,
                  automaticValidation: isValidation,
                  validityPeriod: currentPusblishDuration.name,
                };
                props.onValidation(values.id, sendedBody);
                setIsModifying(false);
              }}
            >
              Valider
            </BtnBleu>
            <BtnBlanc
              btnAction={() => {
                setIsFlux(values.flow);
                setIsValidation(values.automaticValidation);
                setCurrentPusblishDuration(
                  delaiData.filter(
                    (delai) => delai.name === values.validityPeriod
                  )[0]
                );
                setIsModifying(false);
              }}
            >
              Annuler
            </BtnBlanc>
          </div>
        </div>
      </Modal>
    </div>
  );
};

GestionDiffuseurCard.propTypes = {
  diffuseurInfos: PropTypes.object,
  onValidation: PropTypes.func,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GestionDiffuseurCard);
